import { Skeleton } from "@mui/material";

import styles from "./SkeletonCell.module.css";

/**
 * Cell content for a placeholder row.
 */
export function SkeletonCell() {
  return (
    <span className={styles.cell}>
      <Skeleton variant="rounded" animation="wave" className={styles.bar} />
    </span>
  );
}
